export const ROOT = `/`;
export const NO_MATCHES = `*`;
// export const APIv1 = `/api/v1`;
export const APIv2 = `/api/v2`;
